// extracted by mini-css-extract-plugin
export default {"fishAmountInput":"style_fishAmountInput__mYm6N"};